export const NAV_ITEMS = [
  {
    name: "Home",
  },
  {
    name: "About",
  },
  {
    name: "Experience",
  },
  {
    name: "Education",
  },
  {
    name: "Portfolio",
  },
  {
    name: "Achievements",
  },
  {
    name: "Testimonials",
  }
]